import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MissingDocument } from '../../../model/missing-document';

/**
 * Red "missing documents" frame of an incomplete unemployment application.
 * The comment, when present, is listed as an extra line of the frame.
 * Nothing is rendered without missing documents: each screen then displays
 * the comment on its own, in its own layout.
 */
@Component({
  selector: 'myabvv-incomplete-request-info',
  templateUrl: './incomplete-request-info.component.html',
  standalone: true,
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'incomplete-request-info' }
})
export class IncompleteRequestInfoComponent {
  @Input() set documents(value: MissingDocument[] | null | undefined) {
    this.missingDocuments = (value ?? []).filter(document => document.docType?.trim());
  }
  @Input() set comment(value: string | null | undefined) {
    this.trimmedComment = value?.trim() ?? '';
  }

  missingDocuments: MissingDocument[] = [];
  trimmedComment = '';
}
